import React from 'react';
import { StylishNewButton } from '../DesignSystems/New/StylishNewButton';
import { SharedIcon } from '../SharedIcon/SharedIcon';
import { ScrollableList } from 'components/DesignSystems/ScrollableList';
import rehypeSanitize from 'rehype-sanitize';
import MDEditor from '@uiw/react-md-editor';
import { Components } from 'react-markdown';
import { SitrepSectionType } from '../DisasterGPT/hooks/useSitrepsV2';

type SitrepHistoryPanelProps = {
  onHide: () => void;
  versions: SitrepSectionType;
  markdownComponents?: Components;
};

export const SitrepHistoryPanel: React.FC<SitrepHistoryPanelProps> = ({
  onHide,
  versions,
  markdownComponents,
}) => {
  const handleRestore = (index: number) => {
    versions.versionNumber = index;
    onHide();
  };

  return (
    <div className="sidebar p-3">
      <StylishNewButton
        className={'button button--link p-1 justify-content-end'}
        onClick={onHide}
      >
        <SharedIcon iconName="close" classes="text-white" />
      </StylishNewButton>
      <h4 className="d-flex justify-content-center m-0">History</h4> <hr />
      <ScrollableList>
        {versions.section_versions.map((version: any, index: number) => (
          <div key={index} className="sitrep-history-item">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <span>{new Date(version.timestamp).toLocaleString()}</span>
              <StylishNewButton
                className="button--secondary"
                onClick={() => handleRestore(index)}
              >
                Restore
              </StylishNewButton>
            </div>
            <div className="sitrep-section">
              <div className="sitrep-section-content">
                <MDEditor.Markdown
                  source={version.sitrep_section_text}
                  components={markdownComponents}
                  rehypePlugins={[[rehypeSanitize]]}
                />
              </div>
            </div>
            <hr />
          </div>
        ))}
      </ScrollableList>
    </div>
  );
};
